import { UtilityService } from '@eforall/common';
import { GridSetup } from '@eforall/dashboard';
import { Award } from '@interfaces';
import { AppService } from '../../../../../../services';
import { getActions } from './get-actions';
import { getColumns } from './get-columns';


export function getSetup(util: UtilityService, app: AppService): GridSetup<Award> {

	return {
		rowName: { singular: 'Award', plural: 'Awards' },
		getRowKey: row => '' + row.awardId,
		stateKey: 'finance-awards-entrepreneur-grid',
		actions: getActions(),
		buttons: [],
		columns: getColumns(util, app),
	}
}
